import angular from 'angular';

angular.module("core.application.main").filter("core_application_main_filter_readable", function() {
    // Convert "MACRO_CASE" strings into something more readable.
    // For example:
    //     "MY_TYPE" is converted to "My Type".
    // Also converts true booleans into their readable counterpart.
    // For example:
    //     false is converted to "False"
    //     true is converted to "True"
    return function (input) {
        if (typeof input === "boolean") {
            input = input.toString();
        }
        if (!input || input === "")
            return "";

        input = input.toLowerCase();
        input = input.replaceAll("_", "-")

        return `settlements:status-${input}`

    };

});
